import styled from 'styled-components';

export const StyledLoaderMenuWrapper = styled.div`
    width: 100%;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
`;
